import React from "react";
import "./Success.scss";
import { Link } from "react-router-dom";
import mark from "./../../../check-mark-success.png";

export const SuccessLesson = () => {
  return (
    <div className={"sectionSuccess"}>
      <div className={"forgotBox"}>
        <span className={"spanWelcome"}>Ваша оплата прошла успешно</span>
        <img src={mark} alt="Успешно" />
        <Link className={"batonPay"} style={{fontWeight: 'bold', width: '100%'}} to={"/profile/learn"}>
          Перейти к обучению
        </Link>
      </div>
    </div>
  );
};
